const colors = {
  red: 'hsl(10,90%,65%)',
  lightBlue: '#cbe9ff',
  lightPurple: '#c1abff',
  purple: 'hsl(240,80%,70%)',
  skin: '#FFCAB3',
  lightRed: '#FFC2C2',
  mint: '#D5FCEE',
  turqoise: '#A3F1F1',
  reactBlue: '#00d8ff',
}

const gradients = {
  blueToPurple: `linear-gradient(180deg, ${colors.lightBlue}, ${colors.lightPurple})`,
  skinToRed: `linear-gradient(${colors.skin}, ${colors.lightRed})`,
  mintToTurqoise: `linear-gradient(${colors.mint}, ${colors.turqoise})`
}

export default {
  colors,
  gradients,
}


// WEBPACK FOOTER //
// ./src/style/palette.js